// Class: haxe.io._Float32Array.Float32Array_Impl_

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;
var $import = require("./../../../import_stub").default;

// Constructor

var Float32Array_Impl_ = function(){}

// Meta

Float32Array_Impl_.__name__ = "haxe.io._Float32Array.Float32Array_Impl_";
Float32Array_Impl_.__isInterface__ = false;
Float32Array_Impl_.prototype = {
	
};
Float32Array_Impl_.prototype.__class__ = Float32Array_Impl_.prototype.constructor = $hxClasses["haxe.io._Float32Array.Float32Array_Impl_"] = Float32Array_Impl_;

// Init



// Statics

Float32Array_Impl_.fromBytes = function(bytes,bytePos,length) {
	if(bytePos == null) {
		bytePos = 0;
	}
	if(length == null) {
		length = bytes.length - bytePos >> 2;
	}
	return new Float32Array(bytes.getData(),bytePos,length);
}


// Export

exports.default = Float32Array_Impl_;